import styles from "./Logo.module.scss";

const Logo = () => {
  return <div className={styles.logo}>Griddy</div>;
};

export default Logo;
